import React, { useState } from 'react';
import { CheckCard } from 'components/shared/CheckCard/CheckCard';
import './RoleConfigScaffold.css';

export const RoleConfigScaffold = (props) => {
  const [renderKey, setRenderKey] = useState(0);

  return (
    <div className="RoleConfigScaffold">
      <div className="RoleConfigScaffold_SideBar">
        <div className="RoleConfigScaffold_SideBar_Column">
          <div className="RoleConfigScaffold_SideBar_ColumnTop" />
          <div className="RoleConfigScaffold_SideBar_ColumnBar" />
        </div>
      </div>
      <div className="RoleConfigScaffold_Content">
        <div className="RoleConfigScaffold_Content_Title">{props.singleServicePermissions.serviceName}</div>
        <div className="RoleConfigScaffold_Content_CardContainer">
          {props.singleServicePermissions.actions.map((p, index) => (
            <CheckCard
              index={index}
              description={p.description}
              onClick={
                props.editMode
                  ? (index) => {
                      props.selectionFunc(
                        props.singleServicePermissions.serviceId,
                        props.singleServicePermissions.actions[index]
                      );
                      setRenderKey(renderKey + 1);
                    }
                  : {}
              }
              autoHeight={true}
              customWidth={240}
              checkMode={props.editMode ? true : false}
              altCheck={true}
              isSelected={props.selectedPerms ? props.selectedPerms.some((sp) => sp === p.name) : null}
            />
          ))}
        </div>
      </div>
    </div>
  );
};
